import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";

const SuccessModal = ({ open }) => {
  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        window.location.reload();
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[9999] px-3">
      <div className="bg-gradient-to-b from-green-50 to-white text-center rounded-2xl shadow-2xl w-full max-w-lg p-8 animate-fadeIn">

        {/* Icon Wrapper */}
        <div className="flex justify-center mb-6">
          <div className="bg-green-100 rounded-full p-4 shadow-inner">
            <FontAwesomeIcon
              icon={faCircleCheck}
              className="text-green-600 text-[64px]"
            />
          </div>
        </div>

        {/* Heading */}
        <h2 className="text-2xl font-semibold text-gray-800 mb-2">
          Submission Successful
        </h2>

        {/* Divider */}
        <div className="w-16 h-1 bg-green-400 rounded-full mx-auto mb-4" />

        {/* Message */}
        <p className="text-gray-700 leading-relaxed text-base px-1">
          Your onboarding form has been successfully submitted.
          <br />
          Our team will review the details and contact you shortly.
        </p>


      </div>
    </div>
  );
};

export default SuccessModal;
